// @generated
// topic list page initJson
import { deviationsByType } from './deviations';
import { pickset } from './helpers';

// topNecos and allNecos exports contain static deviations for better testing
// default export contains randomized exampleDeviations for novm testing

const NUM_EXAMPLES = 3;

export const topNecos = [
  {
    typeId: 78,
    itemId: 6,
    name: 'Digital Art',
    description:
      'Where talent meets tech. Brush strokes, special effects, layering and more using digital drawing tools.',
    url: 'https://www.deviantart.lan/?topic=digital-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 4,
    name: 'Fan Art',
    description:
      'Art and fiction inspired by movies, characters, books and comics.',
    url: 'https://www.deviantart.lan/?topic=fan-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 46,
    name: 'Photography',
    description: 'Real life moments captured on cam.',
    url: 'https://www.deviantart.lan/?topic=photography',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 20,
    name: 'Fantasy',
    description:
      'Imagined worlds where anything can happen. Home to dragons, magic and mythical creatures.',
    url: 'https://www.deviantart.lan/?topic=fantasy',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 1,
    name: 'Anime and Manga',
    description:
      'Japanese animated cartoons, videos, comics and graphic novels.',
    url: 'https://www.deviantart.lan/?topic=anime-and-manga',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 37,
    name: 'Resources',
    description:
      'Everything you need for your digital toolkit: icons, cursors, vectors, vexel and more.',
    url: 'https://www.deviantart.lan/?topic=resources',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 24,
    name: 'Cosplay',
    description:
      'Much more than just dress-up. The art of becoming a fictional character, through costume, make-up and performance.',
    url: 'https://www.deviantart.lan/?topic=cosplay',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
];

export const allNecos = [
  {
    typeId: 78,
    itemId: 1,
    name: 'Anime and Manga',
    description:
      'Japanese animated cartoons, videos, comics and graphic novels.',
    url: 'https://www.deviantart.lan/?topic=anime-and-manga',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 2,
    name: 'Comics',
    description:
      'The story of characters or events, told through a sequence of hand drawn or digital drawings.',
    url: 'https://www.deviantart.lan/?topic=comics',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 3,
    name: 'Drawings and Paintings',
    description:
      'Hand drawn pieces and painted artworks of every style and genre.',
    url: 'https://www.deviantart.lan/?topic=drawings-and-paintings',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 4,
    name: 'Fan Art',
    description:
      'Art and fiction inspired by movies, characters, books and comics.',
    url: 'https://www.deviantart.lan/?topic=fan-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 5,
    name: 'Traditional Art',
    description: 'Mosaics, calligraphy, printmaking and more.',
    url: 'https://www.deviantart.lan/?topic=traditional-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 6,
    name: 'Digital Art',
    description:
      'Where talent meets tech. Brush strokes, special effects, layering and more using digital drawing tools.',
    url: 'https://www.deviantart.lan/?topic=digital-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 7,
    name: 'Photo Manipulation',
    description:
      'Altered photos blurring the lines between the real and the imagined.',
    url: 'https://www.deviantart.lan/?topic=photo-manipulation',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 8,
    name: 'Fractal',
    description:
      'The numbers of nature represented in art. Created digitally and reaching for infinity.',
    url: 'https://www.deviantart.lan/?topic=fractal',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 9,
    name: 'Game Art',
    description: 'Concepts and designs for the video game worlds.',
    url: 'https://www.deviantart.lan/?topic=game-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 10,
    name: '3D',
    description:
      'Three-dimensional images and videos. Artworks with width, height and depth: origami, sculpture or 3D animations.',
    url: 'https://www.deviantart.lan/?topic=3d',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 11,
    name: 'Animation',
    description:
      'Moving art: From hand-drawn and stop motion, to CGI and motion graphics.',
    url: 'https://www.deviantart.lan/?topic=animation',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 12,
    name: 'Pixel Art',
    description:
      'Pixels used as building blocks to create fun, unique images - from super retro characters to isometric objects.',
    url: 'https://www.deviantart.lan/?topic=pixel-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 13,
    name: 'Design',
    description:
      'Imagination on your screen: logo art, architecture, graphics and more.',
    url: 'https://www.deviantart.lan/?topic=design',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 17,
    name: 'Adoptables',
    description:
      'Explore the possibilities of character and species bases, adopted and brought to life here.',
    url: 'https://www.deviantart.lan/?topic=adoptables',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 18,
    name: 'DA Related',
    description: 'Inspired by DeviantArt...Events, stamps, designs and more.',
    url: 'https://www.deviantart.lan/?topic=da-related',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 20,
    name: 'Fantasy',
    description:
      'Imagined worlds where anything can happen. Home to dragons, magic and mythical creatures.',
    url: 'https://www.deviantart.lan/?topic=fantasy',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 21,
    name: 'Horror',
    description:
      'Ghouls, ghosts and other dark characters and places. Enter at your own peril....',
    url: 'https://www.deviantart.lan/?topic=horror',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 22,
    name: 'Science Fiction',
    description:
      'Technology and science taken to the extreme. Robots, time travel, surreal worlds and more.',
    url: 'https://www.deviantart.lan/?topic=science-fiction',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 23,
    name: 'Kinky',
    description: 'Art with an edge. Playful, erotic or just plain naughty!',
    url: 'https://www.deviantart.lan/?topic=kinky',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 24,
    name: 'Cosplay',
    description:
      'Much more than just dress-up. The art of becoming a fictional character, through costume, make-up and performance.',
    url: 'https://www.deviantart.lan/?topic=cosplay',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 25,
    name: 'Artisan Crafts',
    description:
      'Handmade, custom pieces of art. Includes jewelry, home decor, fabrics and tiles.',
    url: 'https://www.deviantart.lan/?topic=artisan-crafts',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 26,
    name: 'Sculpture',
    description:
      '3D art, usually carved or casted. Tactile pieces, in a range of materials.',
    url: 'https://www.deviantart.lan/?topic=sculpture',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 27,
    name: 'Tattoo & Body',
    description:
      'Body-art on the skin or the page, and other tattoo-inspired artworks.',
    url: 'https://www.deviantart.lan/?topic=tattoo-and-body',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 28,
    name: 'Street Art',
    description:
      'Where the city is the canvas. Graffiti and self-expression, out on the street.',
    url: 'https://www.deviantart.lan/?topic=street-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 29,
    name: 'Literature',
    description:
      'For lovers of the written word. Stories, prose, essays and more.',
    url: 'https://www.deviantart.lan/?topic=literature',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 33,
    name: 'Characters and Settings',
    description:
      'Explorations of character and place, either as the foundation for future work, or as standalone pieces.',
    url: 'https://www.deviantart.lan/?topic=characters-and-settings',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 34,
    name: 'Fiction',
    description: 'Stories created from the imagination. No facts needed.',
    url: 'https://www.deviantart.lan/?topic=fiction',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 37,
    name: 'Resources',
    description:
      'Everything you need for your digital toolkit: icons, cursors, vectors, vexel and more.',
    url: 'https://www.deviantart.lan/?topic=resources',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 39,
    name: 'Bases',
    description:
      'Find the right base and make it your own. Your adopted character comes to life here.',
    url: 'https://www.deviantart.lan/?topic=bases',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 44,
    name: 'Wallpaper',
    description:
      'Switch up your desktop or mobile screen with these inspiring backdrops.',
    url: 'https://www.deviantart.lan/?topic=wallpaper',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 45,
    name: 'Emoji and Emoticon',
    description:
      'Every emotion as an image or icon. Plus gestures, animals, activities and more.',
    url: 'https://www.deviantart.lan/?topic=emoji-and-emoticon',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 46,
    name: 'Photography',
    description: 'Real life moments captured on cam.',
    url: 'https://www.deviantart.lan/?topic=photography',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
  {
    typeId: 78,
    itemId: 47,
    name: 'Nude Art',
    description: 'The beauty of the human form, captured in a photograph.',
    url: 'https://www.deviantart.lan/?topic=nude-art',
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  },
];

export default {
  topNecos: topNecos.map(neco => ({
    ...neco,
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  })),
  allNecos: allNecos.map(neco => ({
    ...neco,
    exampleDeviations: pickset(deviationsByType.image, NUM_EXAMPLES),
  })),
};
